var ContactComponent = /** @class */ (function () {
    function ContactComponent() {
    }
    ContactComponent.prototype.ngOnInit = function () {
        //$("#example2").DataTable();
        $('#example2 td').click(function (event) {
            // var href = $(this).find("a").attr("href");
            // if(href) {
            //     window.location = href;
            // }
            if (event.target.className != "col-checked") {
                $("#detailModal").modal('show');
            }
        });
    };
    ContactComponent.prototype.clearActionActive = function () {
        $(".action-menu").each(function () {
            $(this).removeClass("active");
        });
    };
    ContactComponent.prototype.CloseModal = function (modalId) {
        $("#" + modalId).modal("hide");
        this.clearActionActive();
    };
    ContactComponent.prototype.newContact = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#exampleModal").modal('show');
    };
    ContactComponent.prototype.delete = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
    };
    ContactComponent.prototype.merge = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#mergeModal").modal('show');
    };
    ContactComponent.prototype.sms = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#smsModal").modal('show');
    };
    ContactComponent.prototype.email = function (event) {
        this.clearActionActive();
        event.target.classList.add("active");
        $("#emailModal").modal('show');
    };
    ContactComponent.prototype.confirmMerge = function () {
        $("#mergeModal").modal('hide');
    };
    ContactComponent.prototype.confirmSMS = function () {
        $("#smsModal").modal('hide');
    };
    ContactComponent.prototype.confirmEmail = function () {
        $("#emailModal").modal('hide');
    };
    return ContactComponent;
}());
export { ContactComponent };



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts.pre-build-optimizer.js